import styled from 'styled-components'
import { Button } from '../../../components'

const SpacedButton = styled(Button)`
    &:not(:last-child) {
        margin-right: 5px;
    }
`

/**
 * This is an extension of the Button component, styled for the ChannelsSubBar component.
 * @param props
 * @returns 
 */
export default function ContentButton({ children, theme = 'secondary', ...rest }: Parameters<typeof Button>[0]) {
    return (
        <SpacedButton
            radius="5"
            theme={theme}
            width="40px"
            {...rest}
        >
            {children}
        </SpacedButton>
    )
}
